import networkCallWrapper from "../utils/networkCallWrapper";

export async function requestLimitUpgrade() {
  const request = await networkCallWrapper({
    url: `v2/limits/user/level`,
    method: "POST",
    service: "wallet"
  });
  return request;
}
